export default "/kiban/_next/static/images/impedance-107b3da2c615f0b6dbd11646d9e5fbba.png";